import {FC, Suspense} from 'react'

import TopBarProgress from 'react-topbar-progress-indicator'
// import {MenuTestPage} from '../pages/AdminPages/'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import { isNumber } from 'lodash'
import { useSelector } from 'react-redux'
import { getUsedFeature } from '../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import Onboarding from '../pages/Common/onboarding'

export const SuspensedView: FC = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={'<TopBarProgress />'}>{children}</Suspense>
}

export const FindUniqArr = (arr1: any[], arr2: any[]) => {
  if (arr1?.length > 0 && arr2?.length > 0) {
    let data1 = arr1.at(0)?.options
    let data2 = arr1.at(1)?.options
    let data3 = arr1.at(2)?.options

    let unique: any[] = data1?.filter((key: any) => arr2?.includes(key?.value)) ?? []
    let unique2: any[] = data2?.filter((key: any) => arr2?.includes(key?.value)) ?? []
    let unique3: any[] = data3?.filter((key: any) => arr2?.includes(key?.value)) ?? []

    return [...unique, ...unique2, ...unique3]
  }
}

export const Optiondata = (arr: any, val: any, label: any) => {
  let options = arr?.map?.((key: any) => ({value: key?.[`${val}`], label: key?.[`${label}`]}))
  if (options?.length > 0) {
    return [...options]
  } else {
    return []
  }
}

export const removeBlankKeys = (obj: any) => {
  return Object.fromEntries(Object.entries(obj).filter(([key, value]) => value !== ''))
}

export const pascalCase = (val: any) => {
  const newValue = val.charAt(0).toUpperCase() + val.slice(1)
  return newValue
}

export const isBase64Image = (base64String: string) => {
  const base64Regex = /^data:image\/(png|jpeg|jpg|gif|bmp|webp);base64,[A-Za-z0-9+/=\s]+$/

  return base64Regex.test(base64String)
}

export const base64ToFile = (base64String: string, fileName: string): File => {
  const [mimeInfo, base64Data] = base64String.split(',')
  const mimeTypeMatch = mimeInfo.match(/:(.*?);/)

  if (!mimeTypeMatch) {
    throw new Error('Invalid base64 string format')
  }

  const mimeType = mimeTypeMatch[1] // Extract MIME type

  const binaryData = atob(base64Data)
  const byteArray = new Uint8Array(binaryData.length)

  for (let i = 0; i < binaryData.length; i++) {
    byteArray[i] = binaryData.charCodeAt(i)
  }

  return new File([byteArray], fileName, {type: mimeType})
}

export const formatNumber = (creditAmount: any) => {
  if (!isNumber(creditAmount)) return '-'; // Ensure it's a number
  return creditAmount % 1 === 0 
    ? creditAmount.toString() // No decimals, show as is
    : creditAmount.toFixed(2); // Format with 2 decimals if it has decimals
};

export const OnboardingCheck: FC = ({children}) => {
  const usedFeatures = useSelector(getUsedFeature)

  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })

  if (usedFeatures?.campaign === false) {
    return <Onboarding />
  }
  
  return <Suspense fallback={'<TopBarProgress />'}>{children}</Suspense>
}